module.exports = __webpack_public_path__ + "static/media/wp5.3c2ccb88.jpg";